import { render, staticRenderFns } from "./Groups.vue?vue&type=template&id=9b3b8c74"
import script from "../services/Groups.js?vue&type=script&lang=js&external"
export * from "../services/Groups.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports